import { type ReactNode } from 'react';
import {
  DndContext,
  type DragEndEvent,
  DragOverlay,
  type DragStartEvent,
  PointerSensor,
  useSensor,
  useSensors,
  closestCorners,
} from '@dnd-kit/core';
import { useState } from 'react';
import type { Deal } from '@/types/table';
import { KanbanCard } from './KanbanCard';

interface KanbanBoardProps {
  children: ReactNode;
  onDragEnd: (event: DragEndEvent) => void;
}

export function KanbanBoard({ children, onDragEnd }: KanbanBoardProps) {
  const [activeDeal, setActiveDeal] = useState<Deal | null>(null);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
  );

  const handleDragStart = (event: DragStartEvent) => {
    const deal = event.active.data.current as Deal | undefined;
    if (deal) {
      setActiveDeal(deal);
    }
  };

  const handleDragEnd = (event: DragEndEvent) => {
    setActiveDeal(null);
    onDragEnd(event);
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCorners}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
    >
      <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-thin">
        {children}
      </div>
      <DragOverlay>
        {activeDeal ? <KanbanCard deal={activeDeal} isDragging /> : null}
      </DragOverlay>
    </DndContext>
  );
}
